import Link, { LinkWrapperProps } from "./wrappers/Link";

type ConditionalLinkProps = Omit<LinkWrapperProps, "href"> & {
    href?: string;
    condition: boolean;
};

export const ConditionalLink = ({ condition, children, ...linkedWrapperProps }: ConditionalLinkProps) => (
    <>
        {condition ? (
            <Link {...linkedWrapperProps} data-testid="auto-id-6433a16a-d8d7-4b4f-bd3c-fff3d40b3f13">
                {children}
            </Link>
        ) : (
            children
        )}
    </>
);
